import * as React from "react";

const UserIcon: React.FC = () => {
    return (
        <svg width={40} height={41} viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_16763_82056)">
                <path
                    d="M19.999 3.818c-9.2 0-16.667 7.467-16.667 16.667 0 9.2 7.467 16.667 16.667 16.667 9.2 0 16.666-7.467 16.666-16.667 0-9.2-7.466-16.667-16.666-16.667zm-8.217 27.134c.717-1.5 5.083-2.967 8.217-2.967 3.133 0 7.516 1.467 8.216 2.967A13.155 13.155 0 0120 33.818c-3.1 0-5.95-1.066-8.217-2.866zm18.817-2.417c-2.384-2.9-8.167-3.883-10.6-3.883-2.434 0-8.217.983-10.6 3.883a13.25 13.25 0 01-2.734-8.05c0-7.35 5.984-13.333 13.334-13.333s13.333 5.983 13.333 13.333a13.25 13.25 0 01-2.733 8.05zm-10.6-18.05a5.818 5.818 0 00-5.834 5.834c0 3.233 2.6 5.833 5.834 5.833 3.233 0 5.833-2.6 5.833-5.834 0-3.233-2.6-5.833-5.833-5.833zm0 8.334a2.497 2.497 0 01-2.5-2.5c0-1.384 1.116-2.5 2.5-2.5 1.383 0 2.5 1.116 2.5 2.5 0 1.383-1.117 2.5-2.5 2.5z"
                    fill="#0C0C0C"
                />
            </g>
            <defs>
                <clipPath id="clip0_16763_82056">
                    <path fill="#fff" transform="translate(0 .485)" d="M0 0H40V40H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(UserIcon);
